export enum EnumEstadoRemitCustom {
  Lng_activity = 1,
  Lng_planned = 2,
  Lg_generado_sct1 = 3,
  Lg_generado_nsct2 = 4,
  Lg_generado_spa = 5,
  Pending = 6
}
